import React, { useMemo, useEffect } from 'react';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import ACDropdown from './ACDropdown';
import { useRootStore } from '../../stores/BridgeProvider';

const AccountSelectAC = props => (
  <Observer
    render={() => {
      const { dataStore } = useRootStore();
      const {
        isValidAccountGroup,
        changeMemoVals,
        sortFunction,
        value,
        prefillDisabled,
        ...rest
      } = props;

      const accounts = dataStore.validAccountArray;

      const filteredAccounts = useMemo(() => {
        const groupedAccounts = [];
        accounts.forEach(account => {
          const { AccountTypeName, TypeId, BankAccountType } = account;
          if (
            isValidAccountGroup &&
            !isValidAccountGroup(TypeId, BankAccountType)
          ) {
            return;
          }
          const optionCategory = groupedAccounts.find(
            group => group.label === AccountTypeName,
          );
          if (!optionCategory) {
            groupedAccounts.push({
              label: AccountTypeName,
              id: TypeId,
              options: [account],
            });
          } else {
            optionCategory.options.push(account);
          }
        });
        return groupedAccounts;
      }, [accounts.length, changeMemoVals]);

      const filteredOptions = accounts.filter(a =>
        isValidAccountGroup(a.TypeId, a.BankAccountType),
      );

      useEffect(() => {
        // If only one possible account option, then prepopulate with that account
        if (!prefillDisabled && !value && filteredAccounts.length === 1) {
          try {
            const category = filteredAccounts[0].options;
            if (category.length === 1) {
              props.onChange(category[0]);
            }
          } catch (e) {
            console.error(e);
          }
        }
      }, [filteredAccounts.length]);

      const options =
        sortFunction && filteredAccounts.length !== 0
          ? sortFunction(filteredAccounts)
          : filteredAccounts;

      const sortedOptions = sortFunction
        ? sortFunction(filteredOptions)
        : filteredOptions;

      return (
        <ACDropdown
          blurOnSelect
          autoSelect
          autoComplete
          openOnFocus
          groupBy={option => option.AccountTypeName}
          options={
            options.length > 0 ? sortedOptions : ['No Accounts Available']
          }
          getOptionLabel={option => {
            return options.length > 0 && option.AccountCode
              ? `${option.AccountCode} - ${option.AccountName}`
              : `${option}`;
          }}
          value={value}
          {...rest}
        />
      );
    }}
  />
);

export default AccountSelectAC;
